import { render, staticRenderFns } from "./ProductMenuLink.vue?vue&type=template&id=431fe490&scoped=true&"
import script from "./ProductMenuLink.vue?vue&type=script&lang=ts&"
export * from "./ProductMenuLink.vue?vue&type=script&lang=ts&"
import style0 from "./ProductMenuLink.vue?vue&type=style&index=0&id=431fe490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431fe490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VItem,VTooltip})
